import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DEFAULT_PAGE_SIZE_LIST } from '../../const';
import { hashingData } from './functionSlice';

export interface IDynamicListState<T> {
    items: T[];
    originalItems: T[];
    currentItemId: string | string[] | null;
    currentItem: T | null;
    spinner: boolean;
    page: number;
    pageSize: number;
    sorter: string[];
}

const initialState: IDynamicListState<any> = {
    items: [],
    originalItems: [],
    currentItemId: null,
    currentItem: null,
    spinner: false,
    page: 1,
    pageSize: +DEFAULT_PAGE_SIZE_LIST,
    sorter: [],
};

const slices: { [key: string]: any } = {};

const storeHash: { [keySlice: string]: { [key: string]: number } } = {};

export const listItemSlice = <T>(nameList: string) => {
    if (slices[nameList]) {
        return slices[nameList];
    }

    slices[nameList] = createSlice({
        name: 'dynamicList',
        initialState,
        reducers: {
            setterDynamicList: (state, action: PayloadAction<Partial<IDynamicListState<T>>>) => {
                if (!storeHash[nameList]) {
                    storeHash[nameList] = {};
                }

                hashingData(storeHash[nameList], action.payload, 'items');
                hashingData(storeHash[nameList], action.payload, 'originalItems');

                if (!Object.keys(action.payload).length) {
                    return state;
                }

                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    });

    return slices[nameList];
};

export const getSetterDynamicListItem = <T>(nameList: string) => listItemSlice<T>(nameList).actions.setterDynamicList;

export const getDynamicListItemSlice = <T>(nameList: string) => listItemSlice<T>(nameList).reducer;
